'use client';
import * as braze from '@braze/web-sdk';

import { publicConfig } from './config';

interface ICampaignFlowStartPayload {
  campaign_name: string;
  brand?: string[];
  SKU?: string[];
}

interface ICampaignFlowFinishPayload {
  campaign_name: string;
  win: boolean;
}

interface ITriggerSurveyPayload {
  campaign_name: string;
}

interface IRemindMePayload {
  campaign_name: string;
  fallback_type: 'notStarted' | 'ended';
  brand?: string[];
}

type CampaignEventPayload =
  | { name: 'campaign_flow_start'; data: ICampaignFlowStartPayload }
  | { name: 'campaign_flow_finish'; data: ICampaignFlowFinishPayload }
  | { name: 'trigger_survey'; data: ITriggerSurveyPayload }
  | { name: 'remind_me'; data: IRemindMePayload };

const { APP_NAME } = publicConfig();

export function trackCampaignEvent(event: CampaignEventPayload) {
  braze.logCustomEvent(event.name, { ...event.data, channel: APP_NAME === 'off-trade' ? 'Off_Trade' : 'On_Trade' });
}

export function manageSubscriptions(
  consent: boolean,
  subscriptions?: {
    brand: string;
    subscriptions: string[];
  },
) {
  if (!subscriptions?.subscriptions.length) return;
  const user = braze.getUser();
  braze.openSession();
  subscriptions.subscriptions.forEach((sb) => {
    if (consent) {
      user?.addToSubscriptionGroup(sb);
    } else {
      user?.removeFromSubscriptionGroup(sb);
    }
  });
}
